/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import CHART_CARD from "./CHART_CARD"; // adjust path if needed

/*REDUX*/
import { set_value_sini_data } from "../../App/actions/sini_data_actions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

class S_D_CHAT_GRAPH extends Component {
  state = {
    graph_types: [
      "bar",
      "line",
      "doughnut",
      "pie",
      "polarArea",
      "radar",
      "bubble",
      "scatter",
      "area",
    ],
    selected_graph: "",
  };

  on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  };

  render() {
    const result_list = this.props.result_list || [];

    return (
      <main>
        {result_list.map((layer_result, idx) => {
          const graph_from_field_config_list =
            layer_result?.result_object?.gen_graph
              ?.graph_from_field_config_list || [];

          const graph_from_assistant_output_config_list =
            layer_result?.result_object?.gen_graph
              ?.graph_from_assistant_output_config_list || [];

          return (
            <div key={idx} className="margin_bottom">
              <section>
                {graph_from_field_config_list.map((graph_result, i) => {
                  return (
                    <div>
                      {/* <p>Field</p> */}
                      <CHART_CARD
                        key={`assistant_${i}`}
                        GRAPH_RESULT={graph_result}
                        TITLE_KEY="field_name"
                      />
                    </div>
                  );
                })}
              </section>
              <section>
                {graph_from_assistant_output_config_list.map(
                  (graph_result, i) => {
                    console.log({ graph_result });
                    return (
                      <div>
                        {/* <p>Assistant</p> */}
                        <CHART_CARD
                          key={`assistant_${i}`}
                          GRAPH_RESULT={graph_result}
                          TITLE_KEY="title"
                        />
                      </div>
                    );
                  }
                )}
              </section>
            </div>
          );
        })}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  project: state.project,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
});

export default connect(mapStateToProps, { set_value_sini_data })(
  S_D_CHAT_GRAPH
);
